module.exports = __webpack_public_path__ + "static/floorplan5-6ce7df24de834c6b40abff6b5daef40a.png";